import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,600;1,400&family=DM+Sans:wght@300;400;500&display=swap');

  .blog3-root {
    font-family: 'DM Sans', sans-serif;
    background: #FAFAF8;
    min-height: 100vh;
    color: #1a1a18;
  }

  .blog3-hero {
    background: #0f2318;
    padding: 80px 24px 64px;
    text-align: center;
    position: relative;
    overflow: hidden;
  }

  .blog3-hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse at 60% 0%, rgba(29,158,117,0.18) 0%, transparent 65%),
                radial-gradient(ellipse at 20% 100%, rgba(29,158,117,0.10) 0%, transparent 60%);
  }

  .blog3-tag {
    display: inline-block;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #5DCAA5;
    background: rgba(93,202,165,0.12);
    border: 1px solid rgba(93,202,165,0.25);
    border-radius: 100px;
    padding: 5px 14px;
    margin-bottom: 28px;
    position: relative;
  }

  .blog3-hero-title {
    font-family: 'Lora', Georgia, serif;
    font-size: clamp(28px, 5vw, 52px);
    font-weight: 600;
    line-height: 1.2;
    color: #f5f3ee;
    max-width: 760px;
    margin: 0 auto 20px;
    position: relative;
  }

  .blog3-hero-meta {
    font-size: 13px;
    color: rgba(245,243,238,0.45);
    position: relative;
    letter-spacing: 0.02em;
  }

  .blog3-hero-meta span {
    margin: 0 8px;
  }

  .blog3-body {
    max-width: 720px;
    margin: 0 auto;
    padding: 64px 24px 96px;
  }

  .blog3-intro {
    font-size: 19px;
    line-height: 1.75;
    color: #2a2a26;
    font-weight: 300;
    margin-bottom: 48px;
    padding-bottom: 48px;
    border-bottom: 1px solid #e8e6e0;
  }

  .blog3-section {
    margin-bottom: 52px;
    opacity: 0;
    transform: translateY(18px);
    transition: opacity 0.5s ease, transform 0.5s ease;
  }

  .blog3-section.visible {
    opacity: 1;
    transform: translateY(0);
  }

  .blog3-h2 {
    font-family: 'Lora', Georgia, serif;
    font-size: 26px;
    font-weight: 600;
    color: #0f2318;
    margin: 0 0 18px;
    line-height: 1.3;
  }

  .blog3-p {
    font-size: 16px;
    line-height: 1.8;
    color: #3a3a36;
    margin: 0 0 16px;
    font-weight: 300;
  }

  .reason-block {
    border-left: 3px solid #1D9E75;
    padding: 20px 24px;
    margin: 20px 0;
    background: #fff;
    border-radius: 0 12px 12px 0;
    box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  }

  .reason-number {
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #1D9E75;
    margin-bottom: 6px;
  }

  .reason-title {
    font-size: 17px;
    font-weight: 500;
    color: #1a1a18;
    margin-bottom: 8px;
  }

  .reason-desc {
    font-size: 15px;
    line-height: 1.75;
    color: #4a4a46;
    font-weight: 300;
    margin: 0;
  }

  .blog3-callout {
    background: #0f2318;
    border-radius: 12px;
    padding: 28px 32px;
    margin: 40px 0;
    position: relative;
    overflow: hidden;
  }

  .blog3-callout::before {
    content: '';
    position: absolute;
    top: 0; right: 0;
    width: 180px; height: 180px;
    background: radial-gradient(circle, rgba(93,202,165,0.15) 0%, transparent 70%);
    border-radius: 50%;
    transform: translate(40%, -40%);
  }

  .blog3-callout-text {
    font-family: 'Lora', Georgia, serif;
    font-size: 20px;
    font-style: italic;
    color: #f5f3ee;
    line-height: 1.6;
    margin: 0;
    position: relative;
  }

  .blog3-callout-text em {
    color: #5DCAA5;
    font-style: normal;
  }

  .checklist {
    list-style: none;
    padding: 0;
    margin: 16px 0 0;
  }

  .checklist li {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    padding: 10px 0;
    border-bottom: 1px solid #e8e6e0;
    font-size: 15px;
    color: #3a3a36;
    line-height: 1.6;
    font-weight: 300;
  }

  .checklist li:last-child {
    border-bottom: none;
  }

  .check-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: rgba(29,158,117,0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .check-icon svg {
    width: 11px;
    height: 11px;
  }

  .divider {
    border: none;
    border-top: 1px solid #e8e6e0;
    margin: 48px 0;
  }

  .blog3-cta {
    background: #0f2318;
    border-radius: 16px;
    padding: 48px 40px;
    text-align: center;
    margin-top: 64px;
    position: relative;
    overflow: hidden;
  }

  .blog3-cta::after {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse at 50% 100%, rgba(93,202,165,0.2) 0%, transparent 60%);
  }

  .blog3-cta-title {
    font-family: 'Lora', Georgia, serif;
    font-size: 28px;
    font-weight: 600;
    color: #f5f3ee;
    margin: 0 0 12px;
    position: relative;
    z-index: 1;
  }

  .blog3-cta-sub {
    font-size: 15px;
    color: rgba(245,243,238,0.55);
    margin: 0 0 28px;
    position: relative;
    z-index: 1;
  }

  .blog3-cta-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #1D9E75;
    color: #fff;
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 500;
    padding: 14px 28px;
    border-radius: 100px;
    border: none;
    cursor: pointer;
    position: relative;
    z-index: 1;
    transition: background 0.2s, transform 0.15s;
    text-decoration: none;
  }

  .blog3-cta-btn:hover {
    background: #5DCAA5;
    transform: translateY(-1px);
  }
`;

const reasons = [
  {
    n: "Reason 01",
    title: "Customers expect instant answers — even at 2am",
    desc: "When someone lands on your website at midnight wondering about your pricing, they won't wait until morning. They'll find a competitor who answers right now. An AI chatbot responds in seconds, 24 hours a day, 7 days a week — so you never lose a lead to bad timing.",
  },
  {
    n: "Reason 02",
    title: "You're losing leads you don't even know about",
    desc: "Most website visitors leave without making contact. They had a question, couldn't find the answer quickly enough, and bounced. A chatbot intercepts these visitors before they leave — asks what they need, answers it, and captures their details for follow-up.",
  },
  {
    n: "Reason 03",
    title: "It frees you from repetitive questions",
    desc: "How many times a week do you answer the same questions? Hours, pricing, services, location, booking process. An AI chatbot handles all of these automatically, freeing you to focus on work that actually grows the business.",
  },
  {
    n: "Reason 04",
    title: "It makes your business look bigger than it is",
    desc: "A professional, responsive chat widget signals to visitors that your business is established and takes customer service seriously. It's the same impression a large company with a full support team gives — available to any small business in minutes.",
  },
  {
    n: "Reason 05",
    title: "It pays for itself almost immediately",
    desc: "Even one extra lead per week that converts into a paying customer will cover the cost of most chatbot tools many times over. Most businesses see a return within the first month — often within the first week.",
  },
];

export default function WispyBlogPost3() {
  const [visible, setVisible] = useState({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setVisible((v) => ({ ...v, [e.target.id]: true }));
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".blog3-section").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>Why Every Small Business Website Needs an AI Chatbot in 2026 | Wispy AI</title>
        <meta name="description" content="Customers expect instant answers 24/7. Calls go to voicemail. Emails sit unanswered. Here's why an AI chatbot is the most impactful upgrade you can make to your small business website." />
        <meta property="og:title" content="Why Every Small Business Website Needs an AI Chatbot in 2026 | Wispy AI" />
        <meta property="og:description" content="Customers expect instant answers 24/7. Here's why an AI chatbot is the most impactful upgrade for your small business website." />
        <meta property="og:url" content="https://wispyaii.com/blog/ai-chatbot-small-business" />
        <meta property="og:type" content="article" />
      </Helmet>
      <style>{styles}</style>
      <article className="blog3-root">
        <header className="blog3-hero">
          <div className="blog3-tag">AI Strategy · Small Business · 2026</div>
          <h1 className="blog3-hero-title">
            Why Every Small Business Website Needs an AI Chatbot in 2026
          </h1>
          <p className="blog3-hero-meta">
            <span>8 min read</span>·<span>No technical knowledge needed</span>·<span>Works on any website</span>
          </p>
        </header>

        <div className="blog3-body">
          <p className="blog3-intro">
            Customers expect instant answers 24/7. Calls go to voicemail. Emails sit unanswered for hours. Meanwhile, your competitors are picking up the leads you're losing. An AI chatbot is no longer a nice-to-have — it's the single most impactful upgrade most small business websites can make right now.
          </p>

          {/* Section 1 */}
          <section
            id="problem"
            className={`blog3-section${visible["problem"] ? " visible" : ""}`}
          >
            <h2 className="blog3-h2">The Problem With How Most Small Business Websites Work</h2>
            <p className="blog3-p">
              Most small business websites are essentially digital brochures. They look good, describe what you do, and then… wait. They wait for a visitor to pick up the phone, fill out a form, or send an email. The problem is that most visitors won't do any of those things.
            </p>
            <p className="blog3-p">
              They're browsing. They have a quick question. They want an instant answer. When they don't get one, they leave — often to a competitor whose website does respond immediately.
            </p>
            <div className="blog3-callout">
              <p className="blog3-callout-text">
                The average website visitor makes a decision about whether to stay or leave within <em>8 seconds</em>. If they can't find what they need fast, they're gone.
              </p>
            </div>
          </section>

          <hr className="divider" />

          {/* Section 2 */}
          <section
            id="reasons"
            className={`blog3-section${visible["reasons"] ? " visible" : ""}`}
          >
            <h2 className="blog3-h2">5 Reasons Your Small Business Needs an AI Chatbot</h2>
            <p className="blog3-p">These aren't theoretical benefits. They're the reasons small business owners who add a chatbot almost never remove it.</p>
            {reasons.map((reason) => (
              <div className="reason-block" key={reason.n}>
                <div className="reason-number">{reason.n}</div>
                <div className="reason-title">{reason.title}</div>
                <p className="reason-desc">{reason.desc}</p>
              </div>
            ))}
          </section>

          <hr className="divider" />

          {/* Section 3 */}
          <section
            id="what-it-does"
            className={`blog3-section${visible["what-it-does"] ? " visible" : ""}`}
          >
            <h2 className="blog3-h2">What an AI Chatbot Actually Does for Your Business</h2>
            <p className="blog3-p">A good AI chatbot isn't just a FAQ widget. Here's what it handles day-to-day:</p>
            <ul className="checklist">
              {[
                "Answers questions about your services, pricing, location, and availability — instantly",
                "Captures visitor names and email addresses before they leave",
                "Books appointments and sends confirmations automatically",
                "Qualifies leads by asking the right questions upfront",
                "Handles after-hours enquiries so nothing falls through the cracks",
                "Escalates complex questions to you when needed, with full context",
              ].map((item) => (
                <li key={item}>
                  <span className="check-icon">
                    <svg viewBox="0 0 12 12" fill="none">
                      <path d="M2 6l3 3 5-5" stroke="#1D9E75" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <hr className="divider" />

          {/* Section 4 */}
          <section
            id="objections"
            className={`blog3-section${visible["objections"] ? " visible" : ""}`}
          >
            <h2 className="blog3-h2">Common Objections — Answered</h2>
            {[
              ["\"My customers prefer talking to a real person.\"", "So do most customers — but they prefer talking to a real person over being ignored by one. A chatbot handles the initial contact, captures their details, and hands off to you for the conversation that matters. Nobody is replaced."],
              ["\"I don't have time to set it up.\"", "Modern chatbot tools like Wispy AI are designed to set up in under 10 minutes. There's no coding, no complex configuration. You paste one line of code and train it on your existing FAQ."],
              ["\"It's too expensive for a small business.\"", "Most small business chatbot tools cost less per month than a single lunch out. And one captured lead that converts pays for months of the subscription. The maths works very clearly in your favour."],
              ["\"My website doesn't get enough traffic.\"", "Even with modest traffic, the visitors you do get are more valuable than you might think. A chatbot maximises the conversion rate of every single visitor — making your existing traffic work harder without spending more on ads."],
            ].map(([q, a]) => (
              <div key={q} style={{ borderLeft: "3px solid #5DCAA5", paddingLeft: 20, marginBottom: 24 }}>
                <p style={{ fontWeight: 500, color: "#1a1a18", fontSize: 15, marginBottom: 6 }}>{q}</p>
                <p style={{ color: "#5a5a56", fontSize: 15, lineHeight: 1.7, fontWeight: 300, margin: 0 }}>{a}</p>
              </div>
            ))}
          </section>

          <hr className="divider" />

          {/* Section 5 */}
          <section
            id="getting-started"
            className={`blog3-section${visible["getting-started"] ? " visible" : ""}`}
          >
            <h2 className="blog3-h2">How to Get Started Today</h2>
            <p className="blog3-p">
              You don't need a developer, a big budget, or weeks of planning. Here's all it takes:
            </p>
            <ul className="checklist">
              {[
                "Sign up for a free Wispy AI account — takes under 2 minutes",
                "Give your chatbot a name and describe your business in plain English",
                "Copy your embed code and paste it into your website (works on any platform)",
                "Test it once, then go live — your chatbot is working from that moment on",
              ].map((item) => (
                <li key={item}>
                  <span className="check-icon">
                    <svg viewBox="0 0 12 12" fill="none">
                      <path d="M2 6l3 3 5-5" stroke="#1D9E75" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <p className="blog3-p" style={{ marginTop: 24 }}>
              The whole process takes less than 10 minutes. Need a step-by-step walkthrough? Read our guide: <a href="/blog/how-to-add-chatbot-to-website" style={{ color: "#1D9E75", fontWeight: 500 }}>How to Add a Chatbot to Your Website</a>.
            </p>
          </section>

          {/* CTA */}
          <section
            id="cta"
            className={`blog3-section${visible["cta"] ? " visible" : ""}`}
          >
            <div className="blog3-cta">
              <p className="blog3-cta-title">Start capturing leads you're currently losing</p>
              <p className="blog3-cta-sub">
                Wispy AI sets up in minutes — no coding, no credit card, no commitment.
              </p>
              <a href="https://wispyaii.com/register" className="blog3-cta-btn">
                Try Wispy AI free
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8h10M9 4l4 4-4 4" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
            </div>
          </section>
        </div>
      </article>
    </>
  );
}
